import { Outlet } from '@faceup/router'
import { Suspense } from 'react'
import FaceUpLogo from '../../../assets/logo-fu.svg'
import { Footer } from '../../../Components/Footer/Footer'
import { FullScreenLoader } from '../../../Components/FullScreenLoader'
import { Header } from '../../../Components/Header/Header'
import { SimpleHeaderContent } from '../../../Components/Header/SimpleHeaderContent'
import { useClient } from '../../ClientProvider'

export const DisclosureSubmissionFormWrapper = () => {
  const { client } = useClient()

  return (
    <div className='grid min-h-screen grid-rows-[auto_1fr]'>
      <Header>
        <SimpleHeaderContent
          isApp={client === 'app'}
          isHiddenBackButton
          homepageLinkCallback={routes => routes.home()}
          logoSlot={<img className='max-h-8 w-auto' src={FaceUpLogo} alt='FaceUp' />}
          languages={null}
          defaultLanguage={undefined}
        />
      </Header>
      <div className='flex flex-col justify-center'>
        <Suspense fallback={<FullScreenLoader />}>
          <Outlet />
        </Suspense>
        <Footer hideSecuredBanner />
      </div>
    </div>
  )
}
